<!-- components/CopiableText.vue -->
<template>
  <div class="copiable-text">
    <!-- Label -->
    <label v-if="label" class="label">{{ label }}</label>

    <!-- Value box -->
    <div class="value-box">
      <span class="value">{{ text || placeholder }}</span>
      <v-btn
          v-if="text"
          small icon text
          @click="copy"
          class="copy-btn"
      >
        <v-icon small>mdi-content-copy</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ToastBus from "@/utils/ToastBus";

export default {
  name: "CopiableText",
  props: {
    label: { type: String, default: "" },
    text: { type: String, default: "" },
    // Shown inside the value box when there is nothing to copy.
    placeholder: { type: String, default: "—" }
  },
  methods: {
    async copy() {
      if (!this.text) return;
      try {
        await navigator.clipboard.writeText(this.text);
        this.$emit("copied", this.text);
        ToastBus.$emit("show", "Copied to clipboard!"); // ✅ show toast
      } catch (e) {
        console.error("Copy failed:", e);
      }
    }
  }
};
</script>

<style scoped>
.copiable-text {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
}

.label {
  font-size: 0.85rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #111;
  margin-bottom: 4px;
  letter-spacing: 0.05em;
}

.value-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #000;
}

.value {
  flex: 1;
  word-break: break-all;
}

.copy-btn {
  color: #444;
}
.copy-btn:hover {
  color: #000;
}

/* Dark theme — light styling is left untouched; these only fix visibility
   on dark pages (e.g. the application show page), where the label was
   dark-on-dark and the value box was a harsh white rectangle. */
.theme--dark .label {
  color: #b8bcc8;
}
.theme--dark .value-box {
  background: #1e1f26;
  border-color: rgba(255, 255, 255, 0.14);
  color: #e7e8ee;
}
.theme--dark .copy-btn {
  color: #8b8d9e;
}
.theme--dark .copy-btn:hover {
  color: #e4e5eb;
}
</style>